import { render } from "./DuplicateMultipleTests.vue?vue&type=template&id=36f04ac5&scoped=true"
import script from "./DuplicateMultipleTests.vue?vue&type=script&lang=js"
export * from "./DuplicateMultipleTests.vue?vue&type=script&lang=js"

import "./DuplicateMultipleTests.vue?vue&type=style&index=0&id=36f04ac5&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f04ac5"]])

export default __exports__